import manifest_45route_45rule from "/home/runner/work/immerhe.im/immerhe.im/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}